import DateFnsUtils from '@date-io/date-fns'
import type { PropsWithChildren } from 'react'

import DateFilter from 'pageContainers/TransactionsPage/components/FiltersBlock/components/DateFilter'
import type { DateRangeProps } from 'pageContainers/TransactionsPage/components/FiltersBlock/utils'
import { MuiPickersUtilsProvider } from 'src/components/DatePicker/MuiPickersUtilsProvider'

import classes from './styles.module.scss'

type Props = {
  handleChange: (range: DateRangeProps) => void
}

export default function FiltersBlock({ children, ...props }: PropsWithChildren<Props>) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        <DateFilter {...props} />
        {children}
      </div>
    </MuiPickersUtilsProvider>
  )
}
